import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemCards = function IconSystemCards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15.429 6.29V3.589c0-.9 0-1.349-.2-1.625a1.15 1.15 0 0 0-.752-.454c-.349-.056-.78.132-1.643.509l-6.71 3.343c-.77.336-1.154.504-1.436.765-.25.23-.44.511-.556.822C4 7.299 4 7.7 4 8.502v5.352m0-4.106v9.294c0 1.21 0 1.816.25 2.278.218.407.568.737.998.944.489.236 1.129.236 2.41.236h8.685c1.28 0 1.92 0 2.409-.236.43-.207.78-.537.999-.944.249-.462.249-1.068.249-2.278V9.748c0-1.21 0-1.816-.25-2.278a2.228 2.228 0 0 0-.998-.945c-.489-.235-1.129-.235-2.41-.235H7.658c-1.28 0-1.92 0-2.409.235-.43.207-.78.538-.999.945C4 7.932 4 8.537 4 9.748"
  }));
};